module.exports = __webpack_public_path__ + "static/media/five-leaves.25f3da03.jpg";